import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { GlobalService } from '../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var FavoritePropertiesService = /** @class */ (function () {
    function FavoritePropertiesService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.favoritePropertiesCount = new BehaviorSubject(0);
        this.reloadFavoritePropertiesBar = new BehaviorSubject(false);
        this.displayMaxFavCountErrorMessageDialog = new BehaviorSubject(false);
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    FavoritePropertiesService.prototype.setFavoritesCount = function (updatedCount) {
        this.favoritePropertiesCount.next(updatedCount);
    };
    FavoritePropertiesService.prototype.getFavoritesCount = function () {
        return this.favoritePropertiesCount.asObservable();
    };
    FavoritePropertiesService.prototype.setReloadFavoritePropertiesBar = function (reload) {
        this.reloadFavoritePropertiesBar.next(reload);
    };
    FavoritePropertiesService.prototype.getReloadFavoritePropertiesBar = function () {
        return this.reloadFavoritePropertiesBar.asObservable();
    };
    FavoritePropertiesService.prototype.setDisplayMaxFavCountErrorMessageDialog = function (display) {
        this.displayMaxFavCountErrorMessageDialog.next(display);
    };
    FavoritePropertiesService.prototype.getDisplayMaxFavCountErrorMessageDialog = function () {
        return this.displayMaxFavCountErrorMessageDialog.asObservable();
    };
    FavoritePropertiesService.prototype.updateFavorites = function (propertyId, isFavFlag) {
        var api = _GlobalNS.api.property.updateFavoriteProperties;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&eqrf=" + eqrf, { 'PropertyId': propertyId, 'IsFavorite': isFavFlag }, this.httpOptions);
    };
    FavoritePropertiesService.ngInjectableDef = i0.defineInjectable({ factory: function FavoritePropertiesService_Factory() { return new FavoritePropertiesService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: FavoritePropertiesService, providedIn: "root" });
    return FavoritePropertiesService;
}());
export { FavoritePropertiesService };
